module.exports = __webpack_public_path__ + "static/media/giorgio-armani-si-women-big.c4800168.png";